<template>
  <div class="main">
    <div class="content">
      <div class="container mb10 color-gray-5">
        友情链接：
        <a href="https://sapi.onoa.cn/skill/?app=10"
          >江苏省人力资源行业服务协会</a
        >
        <a href="http://www.jsyyxh.org/">江苏省营养学会</a>
        <a href="http://www.cnaec.com.cn/">中国工程咨询协会</a>
      </div>
      <div class="flex">
        <div class="info">
          <div class="fz16 mb10 color-gray-5 bolder">公司信息</div>
          <a href="http://www.jsyyxh.org/">关于我们</a>
          <a href="http://www.jsyyxh.org/">发展历程</a>
          <a href="http://www.jsyyxh.org/">荣誉资质</a>
        </div>
        <div class="info">
          <div class="fz16 mb10 color-gray-5 bolder">新闻</div>
          <a href="http://www.jsyyxh.org/">企业新闻</a>
          <a href="http://www.jsyyxh.org/">行业动态</a>
        </div>
        <div class="info" style="width: 300px">
          <div class="fz16 mb10 color-gray-5 bolder">联系我们</div>
          <a>客服电话：{{ agentInfo.tel }}</a>
          <a>{{ agentInfo.serviceTime }}</a>
          <a>邮箱：{{ agentInfo.email }}</a>
        </div>
        <div class="code">
          <img :src="agentInfo.customerServiceAccountQrcode" />
          <div>扫一扫关注我们</div>
        </div>
      </div>
    </div>
    <div class="copyright color-gray-5 fz12">
      Copyright © 2022 {{ agentInfo.name }} All Rights Reserved.<span>{{
        agentInfo.recordNumber
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
      agentInfo: {},
    };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  methods: {
    getCustomerServiceSetting() {
      this.api.customerServiceSetting
        .getCustomerServiceSetting()
        .then((res) => {
          this.agentInfo = res.data;
        });
    },
  },
  mounted() {
    this.getCustomerServiceSetting();
    this.list = this.info.wxSchoolPageItemList;
  },
};
</script>
<style lang="less" scoped>
.main {
  background: #262626;
  padding: 24px 0;
  .content {
    width: 1200px;
    text-align: center;
    margin-left: calc(50% - 600px);
    padding-bottom: 24px;
    .container {
      padding: 0 14px;
      text-align: left;
      font-size: 14px;
      margin-bottom: 26px;
      a {
        margin-right: 10px;
        color: #d9d9d9;
        text-decoration: none;
      }
    }
    .info {
      width: 176px;
      height: 163px;
      padding: 0 12px;
      text-align: left;
      a {
        display: block;
        color: #d9d9d9;
        text-decoration: none;
        margin-bottom: 5px;
        font-size: 14px;
      }
    }
    .code {
      height: 163px;
      margin-left: 354px;

      img {
        padding: 10px;
        box-sizing: border-box;
        background: #fff;
        width: 120px;
        height: 120px;
      }
      div {
        text-align: center;
        font-size: 14px;
        color: #d9d9d9;
        margin-top: 6px;
      }
    }
  }
  .copyright {
    padding-top: 12px;
    width: 100%;
    text-align: center;
    border-top: 1px solid #8c8c8c;
    a {
      color: #d9d9d9;
      text-decoration: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/footer/footer1/index.vue